<template>
    <practice-profile-card
        ref="detail"
        class="line-detail-pane mb-6"
        :practice.sync="practice"
        :hideManagementOptions="hideManagementOptions"
    >
        <template slot="actions">
            <vx-action-icon icon="XIcon" hover-color="red" @click="$emit('close-detail')" />
        </template>
    </practice-profile-card>
</template>

<script>
import PracticeProfileCard from './PracticeProfileCard.vue'
export default {
    name: 'practice-line-detail',
    components: { PracticeProfileCard },
    props: {
        practice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            hideManagementOptions: false
        }
    },
    methods: {
        onKeyPress(event) {
            if (event.key == 'Escape') {
                this.close()
            }
        },
        close() {
            this.$emit('close-detail')
        }
    },
    mounted() {
        document.addEventListener('keydown', this.onKeyPress)
    },
    unmounted() {
        document.removeEventListener('keydown', this.onKeyPress)
    }
}
</script>

<style lang="scss" scoped></style>
